import React from 'react';
import { useTranslation } from 'react-i18next';

import { PriceDataPoint, SignalOccurrence } from '../../../types';
import {
  ExternalMarkerGenerator,
  ExternalMarkerGeneratorGetMarkers,
} from './base';

const SignalOccurrenceTooltip: React.FC = () => {
  const [t] = useTranslation();
  return <div>{t('signalOccurred')}</div>;
};

class SignalOccurence extends ExternalMarkerGenerator {
  signalOccurrences: SignalOccurrence[];
  constructor(signalOccurrences: SignalOccurrence[]) {
    super();
    this.signalOccurrences = signalOccurrences || [];
  }

  getMarkers(
    dataPoints: ReadonlyArray<PriceDataPoint>,
    markPointWidth: number
  ): ExternalMarkerGeneratorGetMarkers {
    const signalDates = this.signalOccurrences.map(o => o.date.split('T')[0]);

    const data = [];
    for (const dataPoint of dataPoints) {
      const date = String(dataPoint.date);
      const isSignalOnDate = signalDates.find(d => d === date);
      if (isSignalOnDate) {
        data.push({
          name: 'signal',
          coord: [date, dataPoint.high],
          symbol: 'diamond',
          symbolSize: [markPointWidth, markPointWidth],
          symbolRotate: 0,
          symbolOffset: [0, '-100%'],
          itemStyle: {
            color: 'black',
          },
        });
      }
    }

    const tooltipCreater = (): React.ReactElement => (
      <SignalOccurrenceTooltip />
    );
    return { data, tooltipCreater };
  }
}

export default SignalOccurence;
